/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TelephoneInput from 'shared/ui/components/form-components/TelephoneInput.vue';
import Loader from 'shared/ui/components/Loader.vue';
import MultiFactorCodeControl from 'shared/ui/components/form-components/MultiFactorCodeControl.vue';

/** @enum {number} */
const State = {
    DEFAULT: 1,
    PHONE_CHANGED: 2,
    PHONE_INVALID: 3,
    WAITING_FOR_VERIFICATION: 4,
    VERIFICATION_SENT: 5,
    VERIFICATION_ERROR: 6,
    SAVING: 7,
};

const __vue_script__ = {
    name: 'UserPhone',

    components: { TelephoneInput, Loader, MultiFactorCodeControl },

    props: {
        user: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            buttonLabel: this.$t('profile.details.phone.update_phone_number'),
            currentCode: undefined,
            currentPhone: this.user.mfa_phone,
            currentState: State.DEFAULT,
            disablePhoneInput: false,
            invalidCode: false,
            invalidPhone: false,
            loading: false,
            showCodeInput: false,
            showResendVerification: false,
            token: undefined,
        };
    },

    watch: {
        currentPhone(newPhone) {
            if (
                newPhone?.trim() !== this.user?.mfa_phone.trim()
                && newPhone?.trim() !== ''
            ) {
                this.setState(State.PHONE_CHANGED);
            }
        }
    },

    methods: {
        onButtonClick() {
            if (this.stateIsOneOf([State.PHONE_CHANGED, State.PHONE_INVALID])) {
                this.sendVerificationCode();
            }
            if (this.stateIsOneOf([State.VERIFICATION_SENT, State.VERIFICATION_ERROR])) {
                this.updatePhoneNumber();
            }
            if (this.stateIsOneOf([State.DEFAULT])) {
                this.phoneUnchangedNotification();
            }
        },

        onResend() {
            this.sendVerificationCode(true);
        },

        /** @type {(states: State[]) => boolean} */
        stateIsOneOf(states) {
            return states.includes(this.currentState);
        },

        /** @param {State} state */
        setState(state) {
            this.currentState = state;

            this.buttonLabel = this.stateIsOneOf([State.VERIFICATION_SENT, State.VERIFICATION_ERROR])
                ? this.$t('profile.details.phone.verify_phone_number')
                : this.$t('profile.details.phone.update_phone_number');

            this.disablePhoneInput = !this.stateIsOneOf([State.DEFAULT, State.PHONE_CHANGED, State.PHONE_INVALID]);

            this.loading = this.stateIsOneOf([State.WAITING_FOR_VERIFICATION, State.SAVING]);

            this.invalidPhone = this.stateIsOneOf([State.PHONE_INVALID]);

            this.invalidCode = this.stateIsOneOf([State.VERIFICATION_ERROR]);

            this.showCodeInput = this.stateIsOneOf([State.VERIFICATION_SENT, State.VERIFICATION_ERROR]);

            this.showResendVerification = this.stateIsOneOf([State.VERIFICATION_SENT, State.VERIFICATION_ERROR]);
        },

        /** @param {boolean} [resending] */
        async sendVerificationCode(resending) {
            this.setState(State.WAITING_FOR_VERIFICATION);
            try {
                const res = await this.$services.account.validatePhoneNumber(this.currentPhone.trim());
                if (res.token) {
                    this.token = res.token;
                    this.setState(State.VERIFICATION_SENT);
                    this.successNotification(
                        resending
                            ? this.$t('profile.details.phone.sms_resent')
                            : this.$t('profile.details.phone.sms_sent')
                    );
                }
                if (res.invalidPhoneNumber) {
                    this.setState(State.PHONE_INVALID);
                }
            } catch (err) {
                this.handleUnexpectedError(
                    err,
                    this.$t('profile.details.phone.verification_error'),
                );
            }
        },

        async updatePhoneNumber() {
            if (this.currentCode?.length !== 6 || !this.token) {
                return;
            }
            this.setState(State.SAVING);
            try {
                const res = await this.$services.account.updatePhoneNumber(
                    this.currentCode,
                    this.token,
                );
                if (res.ok) {
                    this.setState(State.DEFAULT);
                    this.successNotification(this.$t('profile.details.phone.updated'));
                }
                if (res.invalidCode) {
                    this.currentCode = undefined;
                    this.setState(State.VERIFICATION_ERROR);
                }
            } catch (err) {
                this.handleUnexpectedError(
                    err,
                    this.$t('profile.details.phone.update_error'),
                );
            }
        },

        phoneUnchangedNotification() {
            this.$notify({
                group: 'flashes',
                text: this.$t('profile.details.phone.unchanged_phone_number'),
                type: 'warning',
            });
        },

        /** @param {string} text */
        successNotification(text) {
            this.$notify({
                group: 'flashes',
                text,
                type: 'success',
            });
        },

        /**
         * @param {Error} err
         * @param {string} text
         */
        handleUnexpectedError(err, text) {
            console.error('[UserPhone] ' + text, err);

            this.$notify({
                group: 'flashes',
                text,
                type: 'error',
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user.mfa_phone
    ? _c(
        "div",
        { staticClass: "user-phone" },
        [
          _vm.loading
            ? _c("loader", { attrs: { status: _vm.loading } })
            : _c(
                "validation-observer",
                { staticClass: "user-forms", attrs: { slim: true } },
                [
                  _c(
                    "validation-provider",
                    { attrs: { slim: true, name: "phoneNumber" } },
                    [
                      _c("telephone-input", {
                        attrs: {
                          name: "phoneNumber",
                          label: _vm.$t("profile.details.phone.phone_number"),
                          disabled: _vm.disablePhoneInput,
                          errors: _vm.invalidPhone
                            ? [_vm.$t("profile.details.phone.invalid_phone")]
                            : undefined,
                        },
                        model: {
                          value: _vm.currentPhone,
                          callback: function ($$v) {
                            _vm.currentPhone = $$v
                          },
                          expression: "currentPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.showCodeInput
                    ? _c(
                        "validation-provider",
                        { attrs: { slim: true, name: "code" } },
                        [
                          _c("multi-factor-code-control", {
                            attrs: {
                              name: "code",
                              label: _vm.$t("profile.details.phone.enter_code"),
                              errors: _vm.invalidCode
                                ? [_vm.$t("profile.details.phone.invalid_code")]
                                : undefined,
                            },
                            model: {
                              value: _vm.currentCode,
                              callback: function ($$v) {
                                _vm.currentCode = $$v
                              },
                              expression: "currentCode",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showResendVerification
                    ? _c(
                        "a",
                        {
                          staticClass: "resend-code",
                          attrs: { href: "#" },
                          on: { click: _vm.onResend },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("profile.details.phone.resend_code"))
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    { staticClass: "btn", on: { click: _vm.onButtonClick } },
                    [_vm._v(_vm._s(_vm.buttonLabel))]
                  ),
                ],
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/user/UserPhone.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__